import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MusicPage from "../components/user/Music";
import {musicService} from "../services"
import Spinner from "../components/UI/Spinner"
import ErrorModal from "../components/UI/Error"

const MusicViewPage = () => {
  const { user, title } = useParams();
  const [music, setMusic] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]=useState(false)
  useEffect(() => {
    const fetchMusic = async () => {
      try {
        setError(false)
        const fanPageMusic = await musicService.musicFanPage(user, title)
        setMusic(fanPageMusic)
      setLoading(true)
      } catch (error) {
        console.error("Error fetching music details:", error);
        setError(true)
      } finally {
        setLoading(false);
      }
    };
    fetchMusic();
  }, [user, title]);

const closeErrorModal=()=>setError(false)

  if (loading) return <div className="h-[60vh] grid place-items-center"><Spinner/></div>
  if (!music)
    //isOpen, onClose, title, message
    return <ErrorModal isOpen={error} onClose={closeErrorModal} title={"Error Fetching Music"} message="There is error while trying to fetch the music. Please check your internet contivities and refresh this page to try again" />;
  return (
 
    <MusicPage music={music.music} hideStats={true}/>
  );
};

export default MusicViewPage;
